module.exports = __webpack_public_path__ + "img/89.30133795.jpg";